import * as React from 'react';
import Markdown from 'react-markdown';
import { useMediaQuery } from '@material-ui/core';
import { DrawerHeader, DrawerBody, Alert, DrawerFooter, Button, } from '@one-thd/sui-atomic-components';
import { useTheme } from '@material-ui/core/styles';
import { LazyImage } from '../../../shared/LazyImage';
import { assets } from '../../../../images/AssetPaths';
import { clickCta, analyticsOverlay, setOverlayEvent, analyticsClick, } from '../../../../utils/analytics';
import { CopyButtonSpinner, Spinner } from '../../../shared/tiers-spinner';
import { PerksRedeemContext } from '../../../../contexts';
import { getCookieProperty, useCopyToClipboard, removeFromUrlParams, } from '../../../Utils';
import { DrawerContext } from '../../../../contexts/drawer-context';
import { redeemInStoreConstant, rhAnalytics, } from '../../../../constants/RewardsHub';
import { BarCode } from '../../../PerksPage/shared/PerksModal/BarCode';
import { getHostURL } from '../../../../utils/GeneralUtil';
import { useDisplayAmount } from '../../../../utils/PerkOptionsUtil';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var base64 = require('base-64');
var iconConstants = assets.cardIcons;
export var OfferDetailsDrawer = function () {
    var _a = React.useContext(PerksRedeemContext), perksRedeem = _a.perksRedeem, getPerksRedeemData = _a.getPerksRedeemData, setPerksRedeem = _a.setPerksRedeem;
    var _b = React.useContext(DrawerContext), setDrawerOpen = _b.setDrawerOpen, details = _b.details, back = _b.back, onBackToList = _b.onBackToList;
    var getDisplayAmount = useDisplayAmount();
    var offer = details;
    var _c = React.useState(true), isLoading = _c[0], setisLoading = _c[1];
    var request = {
        perkSourceUUID: offer === null || offer === void 0 ? void 0 : offer.perkSourceUUID,
        paymentId: offer === null || offer === void 0 ? void 0 : offer.paymentId,
        perkType: offer === null || offer === void 0 ? void 0 : offer.perkType,
        perkId: offer === null || offer === void 0 ? void 0 : offer.perkId,
        activationType: offer === null || offer === void 0 ? void 0 : offer.activationType,
    };
    React.useEffect(function () {
        analyticsOverlay(rhAnalytics.offerDetailsDrawer);
        if (!isMobile && !isTablet && offersOnline) {
            setOverlayEvent('personalized offers your offer');
        }
    }, []);
    var offersOnline = (offer === null || offer === void 0 ? void 0 : offer.activationType) === 'PRICING_ENGINE' &&
        !(offer === null || offer === void 0 ? void 0 : offer.giftCard) &&
        (offer === null || offer === void 0 ? void 0 : offer.availability) === 'ONLINE';
    var cmsOffer = (offer === null || offer === void 0 ? void 0 : offer.activationType) === 'CMS' && !(offer === null || offer === void 0 ? void 0 : offer.giftCard);
    var offersPxd = (offer === null || offer === void 0 ? void 0 : offer.activationType) === 'PAYMENTS' &&
        (offer === null || offer === void 0 ? void 0 : offer.giftCard) &&
        (offer === null || offer === void 0 ? void 0 : offer.availability) === 'OMNI_CHANNEL';
    var cartCount = getCookieProperty('THD_PERSIST', 'C6');
    var handleClose = function () {
        removeFromUrlParams('drawerList');
        setDrawerOpen(false);
        setPerksRedeem(function () { return null; });
    };
    var handleBack = function () {
        onBackToList('OffersList');
        setPerksRedeem(function () { return null; });
    };
    var refreshOffer = function () {
        setisLoading(function () { return true; });
        setPerksRedeem(function () { return null; });
    };
    var LoadCard = function () {
        return (React.createElement("div", null,
            React.createElement(Spinner, { show: 1, preloaderStyle: {
                    position: 'relative',
                    height: '30px',
                    width: '100%',
                }, spinnerStyle: {
                    position: 'relative',
                    height: '15px',
                    width: '15px',
                } })));
    };
    var ErrorCard = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("div", null),
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(LazyImage, { src: assets.icons.error, altText: "info", width: "24px", height: "24px" })),
                    React.createElement("div", null, "Something went wrong. Please try refreshing this offer."))),
            React.createElement("div", null,
                React.createElement("button", { type: "button", onClick: refreshOffer },
                    React.createElement(LazyImage, { src: assets.icons.refresh, altText: "refresh", width: "32px", height: "32px" }),
                    React.createElement("span", null, "Refresh")))));
    };
    var CodeCard = function () {
        var _a = React.useState(false), isLoadingCopy = _a[0], setIsLoadingCopy = _a[1];
        var decodeValue = null;
        var encodedBarCode = perksRedeem && (perksRedeem === null || perksRedeem === void 0 ? void 0 : perksRedeem.barCode);
        if (encodedBarCode !== null ||
            encodedBarCode !== undefined ||
            encodedBarCode.length > 0) {
            decodeValue = base64.decode(encodedBarCode);
        }
        var _b = useCopyToClipboard(decodeValue, setIsLoadingCopy, clickCta), copyUrlStatus = _b[0], copyUrl = _b[1];
        return (React.createElement("div", null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-items-center sui-border-solid sui-border-1 sui-rounded-none sui-border-primary sui-py-6 sui-px-4 sui-mb-8" },
                React.createElement("span", { className: "sui-text-center sui-text-base" }, "Copy Code for Online Purchase"),
                React.createElement("span", { className: "sui-text-center sui-text-base sui-font-bold sui-py-5" }, decodeValue === null || decodeValue === void 0 ? void 0 : decodeValue.replace(/(.{4})(?=.)/g, '$1 ')),
                copyUrlStatus === 'copied' ? (React.createElement(Button, { fullWidth: true, variant: "secondary" },
                    React.createElement("span", null, "Copied to Clipboard"))) : (''),
                copyUrlStatus !== 'copied' && !isLoadingCopy ? (React.createElement(Button, { fullWidth: true, variant: "secondary", onClick: function () {
                        analyticsClick('pro xtra program details: personalized offer: copy discount code');
                        copyUrl();
                    } },
                    React.createElement("span", null, "Copy Code"))) : (''),
                isLoadingCopy ? (React.createElement("div", null,
                    React.createElement(CopyButtonSpinner, { classes: "copy-button-spinner" }))) : (''))));
    };
    var ModalState = function () {
        React.useEffect(function () {
            if (perksRedeem === null) {
                getPerksRedeemData(request);
            }
            else {
                setisLoading(function () { return false; });
            }
        }, [perksRedeem]);
        // if loading
        if (isLoading)
            return React.createElement(LoadCard, null);
        // if error
        if (!perksRedeem ||
            (perksRedeem.errors && perksRedeem.errors.length > 0) ||
            (typeof perksRedeem === 'string' && perksRedeem.length === 0) ||
            Object.keys(perksRedeem).length === 0)
            return React.createElement(ErrorCard, null);
        return React.createElement(CodeCard, null);
    };
    var isMobile = useMediaQuery(useTheme().breakpoints.down('xs'));
    var isTablet = useMediaQuery(useTheme().breakpoints.down('lg'));
    var hideCouponCode = (offer === null || offer === void 0 ? void 0 : offer.availability) === 'IN_STORE' ||
        ((offer === null || offer === void 0 ? void 0 : offer.availability) === 'OMNI_CHANNEL' && (offer === null || offer === void 0 ? void 0 : offer.giftCard));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-pl-2 sui-pt-1 sui-pr-1" }, back ? (React.createElement(DrawerHeader, { title: "Offer Details", onBack: handleBack, onClose: handleClose })) : (React.createElement(DrawerHeader, { title: "Offer Details", onClose: handleClose }))),
        React.createElement(DrawerBody, null, offer && (React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-start sui-align-center sui-h-64 ".concat(isMobile ? '' : 'sui-px-2 sui-pt-1'), style: { minHeight: '64vh' } },
            React.createElement("div", { className: "sui-mb-6 sui-flex sui-items-center" },
                React.createElement("span", { className: "sui-mr-6" },
                    React.createElement(LazyImage, { src: offer === null || offer === void 0 ? void 0 : offer.perkImageUrl, fallbackURL: iconConstants.PersonalOffers, altText: "offer-icon", width: "56px", height: "56px" })),
                React.createElement("div", { className: "sui-text-2xl sui-font-bold" }, "".concat(getDisplayAmount(offer)).concat(offer === null || offer === void 0 ? void 0 : offer.perkTitle))),
            !isMobile && !isTablet && offersPxd && (React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-start sui-align-center sui-pb-8" },
                React.createElement("span", { className: "sui-text-base sui-font-bold" },
                    "Balance:\u00A0 $", "".concat(offer === null || offer === void 0 ? void 0 : offer.availableBalance)))),
            details && isTablet && !offersOnline && (React.createElement("div", { className: "sui-mt-2 sui-w-full sui-mb-8" },
                React.createElement(BarCode, { currentPerkDetails: details }))),
            !hideCouponCode && !cmsOffer && !offersPxd ? (React.createElement(ModalState, null)) : (React.createElement(React.Fragment, null)),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-start sui-align-center" },
                React.createElement("div", { className: "alert-expiration sui-w-full" },
                    React.createElement("div", { className: "sui-w-full sui-text-base" },
                        React.createElement(Alert, { status: "info" },
                            "Expires ",
                            offer && (offer === null || offer === void 0 ? void 0 : offer.expirationTime)))),
                React.createElement("div", { className: "sui-w-full sui-mt-4 sui-text-base sui-leading-relaxed" }, offer && (offer === null || offer === void 0 ? void 0 : offer.perkId) ? (React.createElement(Markdown, { className: "drawer-details-markdown sui-w-full ".concat(!hideCouponCode && !cmsOffer && !offersPxd
                        ? "hidden-coupon-description"
                        : ''), 
                    // eslint-disable-next-line react/no-children-prop
                    children: offer === null || offer === void 0 ? void 0 : offer.perkDescription, renderers: {
                        link: function (props) { return (React.createElement("a", { href: props.href, target: "_blank", rel: "noreferrer" }, props.children)); },
                    } })) : (offer && (offer === null || offer === void 0 ? void 0 : offer.perkDescription))))))),
        React.createElement("div", { className: "sui-p-2" },
            React.createElement(DrawerFooter, null,
                hideCouponCode ? (React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-start sui-align-center sui-pb-8" },
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center sui-align-center sui-min-w-[48px]" },
                        React.createElement(LazyImage, { src: "https://assets.thdstatic.com/images/v1/loyaltyBenefits/icon-mobile.svg", altText: "Mobile Logo" })),
                    React.createElement("div", { className: "sui-pl-4" }, redeemInStoreConstant))) : null,
                !cmsOffer && cartCount > 0 ? (React.createElement("div", { className: "sui-flex sui-gap-2" },
                    React.createElement(Button, { fullWidth: true, variant: "secondary", href: getHostURL('cart') }, "Go To Checkout"))) : null))));
};
